import React from 'react';
import { Button } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const LinkedInAuth = () => {
    const token = localStorage.getItem('linkedinToken');
    if (token) return null;
    const handleLinkedInLogin = () => {
        window.location.href = 'https://api.alumni.live/api/v1/auth/linkedin-auth-for-profile';
    };

    return (
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <Button
                variant="contained"
                startIcon={<LinkedInIcon />}
                onClick={handleLinkedInLogin}
                style={{
                    backgroundColor: '#0077B5',
                    color: '#fff',
                    textTransform: 'none',
                }}
            >
                Sync Linkedin Profile
            </Button>
        </div>
    );
};

export default LinkedInAuth;
